module.exports = __webpack_public_path__ + "img/c377157.jpg";